const McpServerApi = {
    MCP_SERVER_UPDATE_ACTION_TYPE: {
        CREATE_NEW: 'CREATE_NEW',
        UPDATE_BY_ID: 'UPDATE_BY_ID',
        DELETE_BY_ID: 'DELETE_BY_ID',
        TOGGLE_ACTIVE_IN_ORG: 'TOGGLE_ACTIVE_IN_ORG',
        RUN_AUTH: 'RUN_AUTH',
        RUN_TEST: 'RUN_TEST',
        AUTHEN_BY_OAUTH2: 'AUTHEN_BY_OAUTH2',
        AUTHEN_BY_JWT: 'AUTHEN_BY_JWT',
        AUTHEN_BY_BASE: 'AUTHEN_BY_BASE',
        AUTHEN_BY_APIKEY: 'AUTHEN_BY_APIKEY',
        AUTHEN_BY_BEARER: 'AUTHEN_BY_BEARER',
        AUTHEN_BY_NONE: 'AUTHEN_BY_NONE',
        AUTHEN_BY_PERSONAL_CONNECTOR: 'AUTHEN_BY_PERSONAL_CONNECTOR',
        DISCONNECT_PERSONAL_CONNECTOR: 'DISCONNECT_PERSONAL_CONNECTOR'
    },

    MCP_SERVER_GET_METHOD: {
        GET_LIST_PAGINATION: 'GET_LIST_PAGINATION',
        GET_LIST_ACTIVE_MCP_BY_PROJECT: 'GET_LIST_ACTIVE_MCP_BY_PROJECT',
        GET_MCP_SERVER_BY_ID: 'GET_MCP_SERVER_BY_ID',
        GET_MCP_SERVER_BY_ID_NO_VALIDATE: 'GET_MCP_SERVER_BY_ID_NO_VALIDATE',
        GET_MCP_SERVER_BY_ID_LIST: 'GET_MCP_SERVER_BY_ID_LIST',
        GET_MCP_SERVER_BY_OWNER_BY: 'GET_MCP_SERVER_BY_OWNER_BY',
        GET_LOCAL_MCP_CATALOG_LIST: 'GET_LOCAL_MCP_CATALOG_LIST',
        GET_LOCAL_MCP_LIST_FOR_ORG: 'GET_LOCAL_MCP_LIST_FOR_ORG',
        GET_LOCAL_MCP_LIST_FOR_PROJECT: 'GET_LOCAL_MCP_LIST_FOR_PROJECT',
        GET_LIST_MCP_ON_AI_CHAT: 'GET_LIST_MCP_ON_AI_CHAT',
    },

    // --- MCP Catalog API Method ---
    MCP_CATALOG_GET_METHOD: {
        GET_LIST: 'GET_LIST',
        GET_BY_ID: 'GET_BY_ID',
        GET_BY_IDS: 'GET_BY_IDS',
        GET_SNAPSHOTS: 'GET_SNAPSHOTS'
    },

    MCP_CATALOG_UPDATE_METHOD: {
        CREATE: 'CREATE',
        UPDATE: 'UPDATE',
        DELETE: 'DELETE',
        TOGGLE_LOCAL_MCP_IN_ORG: 'TOGGLE_LOCAL_MCP_IN_ORG',
        TOGGLE_LOCAL_MCP_IN_PROJECT: 'TOGGLE_LOCAL_MCP_IN_PROJECT'
    }
};

export default McpServerApi;
